import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h2', {
    staticClass: "page-header__title"
  }, [_vm._v("記事詳細")]), _c('router-link', {
    staticClass: "page-header__button small",
    attrs: {
      "to": {
        name: 'ForumIndex'
      }
    }
  }, [_vm._v(" 一覧に戻る ")])], 1), _setup.data ? _c('div', {
    staticClass: "post"
  }, [_c('div', {
    staticClass: "post__header"
  }, [_setup.data.is_important || _setup.data.created_at !== _setup.data.updated_at ? _c('div', {
    staticClass: "post__header__icons"
  }, [_setup.data.is_important ? _c('TextIcon', {
    attrs: {
      "type": "important"
    }
  }) : _vm._e(), _setup.data.email_status === 'not_sent' && _setup.data.created_at !== _setup.data.updated_at ? _c('TextIcon', {
    attrs: {
      "type": "update"
    }
  }) : _vm._e()], 1) : _vm._e(), _c('h3', {
    staticClass: "post__header__text"
  }, [_vm._v(_vm._s(_setup.data.title))]), _setup.data.attachment.length ? _c('div', {
    staticClass: "post__header__attached"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('title', [_vm._v("添付ファイル")]), _c('path', {
    attrs: {
      "d": "M16.5,6V17.5A4,4 0 0,1 12.5,21.5A4,4 0 0,1 8.5,17.5V5A2.5,2.5 0 0,1 11,2.5A2.5,2.5 0 0,1 13.5,5V15.5A1,1 0 0,1 12.5,16.5A1,1 0 0,1 11.5,15.5V6H10V15.5A2.5,2.5 0 0,0 12.5,18A2.5,2.5 0 0,0 15,15.5V5A4,4 0 0,0 11,1A4,4 0 0,0 7,5V17.5A5.5,5.5 0 0,0 12.5,23A5.5,5.5 0 0,0 18,17.5V6H16.5Z"
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "tool"
  }, [_setup.data.email_status === 'not_sent' && (_setup.me.allow?.admin && _setup.me?.allow?.forum_post || !_setup.me.allow?.admin && _setup.me?.allow?.forum_post && _setup.data.staff_id === _setup.me.id) ? _c('button', {
    staticClass: "edit-button",
    on: {
      "click": function ($event) {
        return _setup.router.push({
          name: 'ForumEdit'
        });
      }
    }
  }, [_vm._v(" 編集 ")]) : _vm._e(), _setup.me.allow?.admin && _setup.me?.allow?.forum_post || !_setup.me.allow?.admin && _setup.me?.allow?.forum_post && _setup.data.staff_id === _setup.me.id ? _c('button', {
    staticClass: "edit-button",
    on: {
      "click": function ($event) {
        return _setup.router.push({
          name: 'ForumCreate',
          params: _setup.dataForCopy
        });
      }
    }
  }, [_vm._v(" 複製 ")]) : _vm._e(), _setup.data.email_status === 'not_sent' && (_setup.me.allow?.admin && _setup.me?.allow?.forum_post || !_setup.me.allow?.admin && _setup.me?.allow?.forum_post && _setup.data.staff_id === _setup.me.id) ? _c('button', {
    staticClass: "delete-button",
    on: {
      "click": function ($event) {
        return _setup.toggleIsShowDeleteConfirmModal();
      }
    }
  }, [_vm._v(" 削除 ")]) : _vm._e()])]), _c('div', {
    staticClass: "post__data"
  }, [_c('time', {
    staticClass: "date",
    attrs: {
      "datetime": _setup.data.published_at
    }
  }, [_vm._v(" " + _vm._s(_setup.cdate(_setup.data.published_at).format("YYYY年MM月DD日 HH時mm分")) + " ")]), _c('p', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_setup.data.author_name))]), _c('p', {
    staticClass: "position"
  }, [_vm._v(_vm._s(_setup.data.staff?.name))]), _c('ForumSchoolCount', {
    attrs: {
      "select-school-id-list": _setup.selectSchoolIdList
    }
  }), _setup.data.email_status === 'sent' ? _c('p', [_vm._v(" 送信数: " + _vm._s(_setup.data.guardian_student_count) + " ")]) : _vm._e()], 1), _c('div', {
    staticClass: "post__period"
  }, [_c('p', {
    staticClass: "post__period__label"
  }, [_vm._v("表示期間：")]), _c('time', {
    staticClass: "post__period__date",
    attrs: {
      "datetime": _setup.cdate(_setup.data.published_at).format('YYYY-MM-DD')
    }
  }, [_vm._v(_vm._s(_setup.cdate(_setup.data.published_at).format("YYYY年MM月DD日(ddd)")))]), _c('span', [_vm._v("〜")]), _c('time', {
    staticClass: "post__period__date",
    attrs: {
      "datetime": _setup.cdate(_setup.data.expire_on).format('YYYY-MM-DD')
    }
  }, [_vm._v(_vm._s(_setup.cdate(_setup.data.expire_on).format("YYYY年MM月DD日(ddd)")))])]), _c('div', {
    staticClass: "post__content"
  }, [_setup.data.message ? _vm._l(_setup.data.message.split('\n'), function (text, i) {
    return _c('span', {
      key: `${i}-${text}`,
      style: {
        'white-space': 'pre-line'
      }
    }, [_c('UrlToLink', {
      attrs: {
        "text": text
      }
    }), _vm._v(_vm._s("\n") + " ")], 1);
  }) : _vm._e(), _setup.data.attachment.length ? _c('div', {
    staticClass: "post__content__attached"
  }, _vm._l(_setup.data.attachment, function (attachment) {
    return _c('ForumAttachmentItem', {
      key: attachment.id,
      attrs: {
        "attachment": attachment
      }
    });
  }), 1) : _vm._e()], 2)]) : _vm._e(), _c('section', {
    staticClass: "other-forum"
  }, [_vm._m(0), _c('div', {
    staticClass: "other-forum__wrapper"
  }, _vm._l(_setup.forumList, function (forum) {
    return _c('ForumItem', {
      key: forum.id,
      attrs: {
        "forum": forum
      }
    });
  }), 1)]), _setup.isShowDeleteConfirmModal ? _c('ConfirmModal', {
    on: {
      "clickOK": _setup.deleteForum,
      "clickCancel": function ($event) {
        return _setup.toggleIsShowDeleteConfirmModal();
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("記事削除")];
      },
      proxy: true
    }, {
      key: "message",
      fn: function () {
        return [_c('p', [_vm._v("記事を削除します。")]), _c('p', [_vm._v("本当に実行してもよろしいですか？")])];
      },
      proxy: true
    }], null, false, 2199151982)
  }) : _vm._e()], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "other-forum__header"
  }, [_c('h3', {
    staticClass: "other-forum__title"
  }, [_vm._v("その他の記事一覧")])]);
}];
export { render, staticRenderFns };